export default [

     {
          path: '/aptitude-grade',
          name: 'AptitudeGrade',
          component: () => import("@/views/Page/AptitudeGrade/AptitudeGrade.vue"),
          meta: {
               title: 'Aptitude Test Grade',
          },
     }
];